const trigger = document.querySelector(".js-duty-roster-photo-upload-init");

if (trigger) {
    globalThis.ret.popupAddFile(trigger);
}
